exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nuance-badges[data-v-0480495d]{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0}.nuance-badges .badge-item[data-v-0480495d]{color:#fff;font-size:11px;padding:3px 10px;border-radius:12px;font-weight:600;letter-spacing:.3px;cursor:help}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0480495d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/layouts/companyNuanceBadges.vue
// module id = 941
// module chunks = 0